var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.6,36.9l12.1,0c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l-7.5,0 l0-13.2c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l0,17.7 c0,1.2,0.5,2.3,1.3,3.2C29.3,36.4,30.4,36.9,31.6,36.9L31.6,36.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.8,2.6C24.2,3,19.2,4.9,14.9,8l3.2,3.2c3.4-2.3,7.4-3.7,11.6-4.1V2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,46.2C9,42.7,7.5,38.6,7.1,34.2H2.6C3,39.9,5,45.1,8.2,49.4L11.4,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,29.8c0.5-6.1,3.3-11.7,7.5-15.7l-3.2-3.2c-5,4.9-8.3,11.5-8.9,18.9H7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,8.2C45.1,5,39.9,3,34.2,2.6v4.5c4.4,0.4,8.5,1.9,11.9,4.3L49.4,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,49.4c-4.1,4.2-9.6,7-15.7,7.5v4.5c7.4-0.6,14-3.8,18.9-8.9L50,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4,34.2h-4.5c-0.4,4.3-1.8,8.2-4.1,11.6l3.2,3.2C59.1,44.8,61,39.8,61.4,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,56.9c-6-0.5-11.5-3.2-15.5-7.3l-3.2,3.2c4.9,4.9,11.4,8.1,18.7,8.6V56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,11.1l-3.2,3.2c4.1,4,6.7,9.5,7.3,15.5h4.5C60.9,22.5,57.7,15.9,52.8,11.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fc16e77b76a6ff3cfc28a1318862a0ca.svg";
export { ForwardRef as ReactComponent };